import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { retrieveRecordDetails } from '~/actions/salesforce'
import { ColumnFlex } from '~/components/common/containers'
import { SecondaryInfo } from '~/components/common/typography'
import Textarea from '~/components/common/textarea'
import { translate } from '~/core/translate'

import Item from './item'

const StyledItem = styled(Item)`
  margin-bottom: 16px;
`

const Container = styled(ColumnFlex)`
  width: 100%;

  ${SecondaryInfo} {
    color: ${({ theme }) => theme.color};
  }
`

const NoteTextArea = styled(Textarea)`
  border-width: 1px;
  height: 132px;
  margin-top: 4px;
  width: 100%;
`

const ItemDetails = ({ notes, onNotesChange, recordId }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(retrieveRecordDetails(recordId))
  }, [dispatch, recordId])

  return (
    <Container>
      <StyledItem recordId={recordId} />

      <SecondaryInfo>{translate('salesforce_add_note')}:</SecondaryInfo>
      <NoteTextArea
        onChange={onNotesChange}
        placeholder={translate('salesforce_add_note_about_meeting')}
        value={notes}
      />
    </Container>
  )
}

export default ItemDetails
